import { FormControl, InputLabel, MenuItem, Select, Grid } from '@material-ui/core';

export interface EnumSelectProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  /**
   * Option values. Pass a `[value, label]` tuple only where the display text differs from the
   * value (e.g. `arm64` shown as `ARM64`); a bare string renders as itself.
   */
  options: ReadonlyArray<string | readonly [string, string]>;
  labelId?: string;
  defaultValue?: string;
  fullWidth?: boolean;
  gridItem?: boolean;
}

/**
 * Outlined single-select over a fixed value list. Replaced the per-field RuntimeSelect /
 * ArchitectureSelect components, which were identical apart from their option list — and each
 * carried its own copy of that list, so the dropdown could offer a value FIELD_VALIDATORS rejects.
 * Callers now pass the allowlist from config-editor-common, which is the same one the backend
 * planner validates against.
 */
export const EnumSelect = ({
  value,
  onChange,
  label,
  options,
  labelId,
  defaultValue,
  fullWidth = true,
  gridItem = false,
}: EnumSelectProps) => {
  const select = (
    <FormControl variant="outlined" size="small" fullWidth={fullWidth}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value || defaultValue || ''}
        onChange={e => onChange(e.target.value as string)}
        label={label}
      >
        {options.map(option => {
          const [optionValue, optionLabel] = typeof option === 'string' ? [option, option] : option;
          return (
            <MenuItem key={optionValue} value={optionValue}>
              {optionLabel}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  return gridItem ? (
    <Grid item xs={12} md={6}>
      {select}
    </Grid>
  ) : (
    select
  );
};
